/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsUrlOpenMethod } from './FxIdDomainSettingsUrlOpenMethod';
import {
    instanceOfFxIdDomainSettingsUrlOpenMethod,
    FxIdDomainSettingsUrlOpenMethodFromJSON,
    FxIdDomainSettingsUrlOpenMethodFromJSONTyped,
    FxIdDomainSettingsUrlOpenMethodToJSON,
} from './FxIdDomainSettingsUrlOpenMethod';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethod
 * способ показа документа PP
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethod = FxIdDomainSettingsUrlOpenMethod;

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethodFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethod {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethodFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethod {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsUrlOpenMethod(json)) {
        return FxIdDomainSettingsUrlOpenMethodFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethodToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethodToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethodToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsUrlOpenMethod(value)) {
        return FxIdDomainSettingsUrlOpenMethodToJSON(value as FxIdDomainSettingsUrlOpenMethod);
    }

    return {};
}

